import axios from "axios";

export const globalSearch = async (query: string, limit = 5) => {
  try {
    const res: any = await axios.get("/search", {
      params: { q: query, limit },
      excludeInterceptor: true,
    } as any);
    return res?.data ? res.data : { results: {}, query, total: 0 };
  } catch (e: any) {
    return { results: {}, query, total: 0 };
  }
};
